<chart [type]="'line'" [data]="lineData" [options]="lineOptions"></chart>